let requestAnimationFrame =
  window.requestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame;
if (!requestAnimationFrame) {
  requestAnimationFrame = window.setTimeout;
}
requestAnimationFrame = window.setTimeout;
window.requestAnimationFrame = requestAnimationFrame;

const scrollTo = (element, to, duration) => {
  if (
    duration <= 0 ||
    (element.scrollHeight - element.clientHeight > 0 &&
      element.scrollTop === element.scrollHeight - element.clientHeight)
  ) {
    return;
  }

  var difference = to - element.scrollTop;
  var perTick = difference / duration * 1;

  requestAnimationFrame(() => {
    element.scrollTop += perTick;
    scrollTo(element, to, duration - 1);
  });
};

export const elementScrollTop = (identifier, destination, adjustment = 0) => {
  scrollTo(
    document.querySelector(identifier),
    document.querySelector(destination).offsetTop + adjustment,
    30
  );
};



// WEBPACK FOOTER //
// ./src/utils/domHelpers.js